(function ($) {
  $(document).ready(function () {
    var homeBlogPosts = $('.home-blog_posts');
    if (homeBlogPosts.length) {
      homeBlogPosts.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }

    // form mouse skew
    var $form = $('.about-wrapper img');
    if ($form.length) {
      $form.tilt({
        maxTilt: 8,
        perspective: 1000,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        speed: 1200,
        glare: true,
        maxGlare: 0.2,
        scale: 1
      });
    }
  });
})(jQuery);